package com.projectas.app.components

import androidx.compose.runtime.Composable
import com.projectas.app.style.LogoStyle
import com.projectas.app.style.TextSelectionStyle
import com.projectas.app.util.Constants.ACME_REGULAR
import com.projectas.app.util.Resource
import com.projectas.app.util.Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.RectF
import com.varabyte.kobweb.silk.theme.shapes.clip
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Header(
    largeBreakpoint: Boolean,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                top = 25.px,
                bottom = if (largeBreakpoint) 0.px else 50.px
            ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Image(
            modifier = LogoStyle.toModifier()
                .size(size = 60.px)
                .clip(RectF(cornerRadius = 16.px))
                .cursor(Cursor.Pointer)
                .margin(right = 12.px),
            src = Resource.Icon.LOGO,
            alt = "Logo Image"
        )
        P(
            attrs = TextSelectionStyle.toModifier()
                .color(Theme.Text.rgb)
                .fontFamily(ACME_REGULAR)
                .fontSize(if (largeBreakpoint) 1.7.cssRem else 1.5.cssRem)
                .lineHeight(value = if (largeBreakpoint) 1.6 else 1.4)
                .margin(right = 6.px)
                .toAttrs()
        ) {
            Text(
                value = "Projectas"
            )
        }
    }
}
